import * as React from 'react';
import ReactDOM = require('react-dom');
import Modul, { OpenConfig, ModuleData } from './Modul';
import { load, update, AppState } from '../module/index';
import { Dispatch } from "redux";
import { Provider, connect } from "react-redux";

import { ViewProps, EditViewProps, WebViewProps } from "./interfaces";
import TabOptions from '../actionBar/interfaces/TabOptions';

import AppRegistry from "diy/AppRegistry";
function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

abstract class ModulWithRedux<TData extends ModuleData> extends Modul {

    hasActionBar = true;
    hasUndoRedo = false;

    protected inPlaceEditorWrapper: HTMLElement;
    protected data: TData;
    abstract getInPlaceEditViewClass(): React.ComponentClass<EditViewProps<TData>>;
    abstract getWebViewClass(): React.ComponentClass<WebViewProps<TData>>;

    open(openConfig?: OpenConfig) {
        getStore().dispatch(load({
            moduleId: this.moduleId,
            moduleState: {
                moduleId: this.moduleId,
                payload: this.data
            }
        }));

        super.open(openConfig);
        this.renderWebView();
        this.renderInPlaceEditView();
    }

    close(userClose?: boolean, cancelEdit?: boolean, isSaving?: boolean, isUserAction?: boolean) {
        if (this.inPlaceEditorWrapper) {
            ReactDOM.unmountComponentAtNode(this.inPlaceEditorWrapper);
            this.inPlaceEditorWrapper.parentElement.removeChild(this.inPlaceEditorWrapper);
            this.inPlaceEditorWrapper = null;
        }
        super.close(userClose, cancelEdit, isSaving, isUserAction);
    }

    protected getConnectedComponent<P extends ViewProps<TData>>(componentClass: React.ComponentClass<P>) {
        const mapStateToProps = (state: AppState) => {
            return {
                moduleId: this.moduleId,
                module: this as ModulWithRedux<TData>,
                payload: state.modules[this.moduleId].payload
            } as P;
        };
        const moduleId = this.moduleId;
        const mapDispatchToProps = (dispatch: Dispatch) => {
            return {
                onDataChange: (data: TData) => {
                    this.data = Object.assign({}, this.data, data);
                    dispatch(update({moduleId, partialPayload: data}));
                }
            } as P;
        };
        const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(componentClass);

        return (
            <Provider store={getStore()}>
                <ConnectedComponent/>
            </Provider>
        );
    }

    renderInPlaceEditView() {
        const inPlaceEditViewClass = this.getInPlaceEditViewClass();
        if (!inPlaceEditViewClass) {
            return;
        }

        this.inPlaceEditorWrapper = document.createElement("div");
        document.body.appendChild(this.inPlaceEditorWrapper);

        ReactDOM.render(
            this.getConnectedComponent(inPlaceEditViewClass),
            this.inPlaceEditorWrapper
        );
    }

    renderWebView() {
        ReactDOM.render(
            this.getConnectedComponent(this.getWebViewClass()),
            this.getContentElement()
        );
    }

    updateModul(cmsView: string, editView: string) {
        // we need to unmount the component because in updateModul the content is replaced in DOM
        const contentEl = this.getContentElement();
        if (contentEl) {
            ReactDOM.unmountComponentAtNode(contentEl);
        }
        super.updateModul(cmsView, editView);
    }

    getSaveData() {
        return Object.assign(this.data,
        {
            moduleId: this.moduleId,
            _diyNewlyAdded: this.getIsNew() ? 1 : 0
        });
    }

    /**
     * If the module needs more than one tab
     * it should return here tabs options
     * By default null is returned.
     * @returns {null}
     */
    getActionBarTabs(): TabOptions[] {
        return null;
    }

    undoHandler = () => {
        /**
         * If the module supports undo/redo
         * it should override these methods
         */
    };
    redoHandler = () => {
        /**
         * If the module supports undo/redo
         * it should override these methods
         */
    };
}

export default ModulWithRedux;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulWithRedux.tsx
 **/